import { alpha, styled } from '@mui/material';
import Stack from '@mui/material/Stack';

export const StyledBadgeStack = styled(Stack)(({ theme }) => ({
  background: theme.palette.createBrandGradients.primary(
    theme.palette.mode === 'dark'
      ? {
          alpha1: alpha(theme.palette.common.black, 0.7),
        }
      : {
          alpha1: alpha(theme.palette.common.white, 0.55),
          alpha2: alpha(theme.palette.common.white, 0.55),
        },
  ),
  borderColor: `${theme.palette.border.primary}!important`,
  alignItems: 'center',
  border: '1px solid',
  width: '100%',
  height: theme.spacing(17),
  top: theme.spacing(-11.75),
  position: 'absolute',
  borderTopLeftRadius: theme.spacing(4),
  borderTopRightRadius: theme.spacing(4),
  zIndex: -1,
  paddingBlockEnd: theme.spacing(5),
  justifyContent: 'center',
  svg: {
    color: theme.palette.utility.gray700,
  },
}));

const BADGE_SEPARATION_MARGIN = 12.5;

export const StyledStack = styled(Stack)(({ theme }) => ({
  position: 'relative',
  height: '100%',
  [theme.breakpoints.down('md')]: {
    marginBlockStart: theme.spacing(BADGE_SEPARATION_MARGIN),
  },
}));
